import { types } from "mobx-state-tree"

export default types.model({
    rowsPerPage: types.number,
    page: types.number
})
.actions(self=>({
    setRowsPerPage: (value)=>{
        self.rowsPerPage = value;
    },
    setPage: (value)=>{
        self.page = value;
    }
}))


// WEBPACK FOOTER //
// ./src/stores/PaginationOptions.js